import './src/base.css';
import './src/light.css';
import './src/dark.css';
import './src/tailwind.css';

// 必须引 否则组件没有样式
import '@bfe/moly/dist/es/theme/cssVars/index.css';
// 必须引 否则组件没有样式
import '@bfe/moly/dist/es/theme/styles/tailwind.css';
// eslint-disable-next-line
import '@web3fe/infra/dist/style.css';
